import UserTableDto from 'app/admin/user/dto/UserTableDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import LabMeasurementReaderTableDto from '../dto/LabMeasurementReaderTableDto';

class LabMeasurementReaderTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'labMeasurementReaderTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<LabMeasurementReaderTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, LabMeasurementReaderTableDto)))
				.catch(reject);
		});
	}
}

export default new LabMeasurementReaderTableService();
